type NavigateFn = (path: string) => void;

let navigateFn: NavigateFn | null = null;
let pendingPath: string | null = null;

export function setPushNavigate(fn: NavigateFn) {
  navigateFn = fn;
  if (pendingPath) {
    const path = pendingPath;
    pendingPath = null;
    fn(path);
  }
}

/**
 * Navigiert bei Tap auf eine Push-Benachrichtigung zu einem internen Pfad.
 * Nutzt react-router (keine Server-Anfrage) statt window.location.href, weil
 * ein harter Reload auf einen Deep-Link bei der BrowserRouter-SPA voraussetzt,
 * dass der Server für jeden Pfad index.html ausliefert - das ist nicht garantiert
 * und führte zu weißem Bildschirm.
 *
 * Falls der Tap die App gerade erst kaltstartet und der Router noch nicht
 * gemountet ist, wird der Pfad gemerkt und sobald setPushNavigate() läuft
 * nachgeholt (statt auf window.location.href zurückzufallen).
 */
export function navigateFromPush(path: string) {
  if (navigateFn) {
    navigateFn(path);
  } else {
    pendingPath = path;
  }
}
